/**
 * The e-invoice profile that determines the specification identifier (BT-24)
 * emitted in the XML. Stored per buyer on the billing profile.
 */
export enum XInvoiceProfileEnum {
  /**
   * Plain EN 16931 (COMFORT) profile, used for B2B invoices and the
   * ZUGFeRD/Factur-X embedding.
   */
  EN16931 = "en16931",

  /**
   * XRechnung 3.0 CIUS, required for german B2G invoicing.
   */
  XRECHNUNG = "xrechnung"
}
